/* @flow */

export default class ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}
